import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { assertNever } from 'owa-assert';
import { AttachmentFolderPickerClientProviderType } from '../store/schema/AttachmentFolderPickerProviderType';
import { AttachmentFolderPickerResult } from '../types/AttachmentFolderPickerResult';
import { AttachmentSelectedFolderIdentifierType } from '../types/AttachmentSelectedFolderInfo';
import { AttachmentSelectedFolderInfo } from '../types/AttachmentSelectedFolderInfo';
import { DEFAULT_ONE_DRIVE_SPECIAL_ATTACHMENT_FOLDER_PATH } from '../constants';
import { getStore } from '../store/store';
import { getUploadFolder } from 'owa-attachments-upload-folder';
import { isGroupProviderViewState, isOneDriveProViewState } from '../utils/typeGuards';

export function getAttachmentFolderPickerResult(): AttachmentFolderPickerResult {
    const { folderSelectorResult, providerViewState } = getStore();

    if (folderSelectorResult && folderSelectorResult.isFolderSelected) {
        const folderInfo: AttachmentSelectedFolderInfo = {
            identifierType: AttachmentSelectedFolderIdentifierType.Id,
            identifier: folderSelectorResult.folderId,
        };

        if (isOneDriveProViewState(providerViewState)) {
            return {
                isFolderSelected: true,
                providerType: AttachmentDataProviderType.OneDrivePro,
                folderInfo,
            };
        } else if (isGroupProviderViewState(providerViewState)) {
            return {
                isFolderSelected: true,
                providerType: AttachmentFolderPickerClientProviderType.Group,
                groupMailboxId: providerViewState.groupMailboxId,
                folderInfo,
            };
        }

        return assertNever(providerViewState);
    }

    return getDefaultAttachmentFolderPickerResult();
}

function getDefaultAttachmentFolderPickerResult(): AttachmentFolderPickerResult {
    const store = getStore();

    if (isOneDriveProViewState(store.providerViewState)) {
        return {
            isFolderSelected: true,
            providerType: AttachmentDataProviderType.OneDrivePro,
            folderInfo: {
                identifierType: AttachmentSelectedFolderIdentifierType.SpecialFolder,
                identifier: DEFAULT_ONE_DRIVE_SPECIAL_ATTACHMENT_FOLDER_PATH,
            },
        };
    } else if (isGroupProviderViewState(store.providerViewState)) {
        return {
            isFolderSelected: true,
            providerType: AttachmentFolderPickerClientProviderType.Group,
            groupMailboxId: store.providerViewState.groupMailboxId,
            folderInfo: {
                identifierType: AttachmentSelectedFolderIdentifierType.Id,
                identifier: getUploadFolder(store.providerViewState.groupMailboxId).folderId,
            },
        };
    }

    return assertNever(store.providerViewState);
}
